'use client';

import { type Resource } from 'i18next';
import { type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import initTranslations, { i18nInstance } from '@/locale/i18n';

export default function TranslationsProvider({
  children,
  locale,
  namespaces,
  resources,
}: {
  children: ReactNode;
  locale: string;
  namespaces: string[];
  resources: Resource;
}) {
  // This is the way that they do in the docs, it's weird but ok.
  void initTranslations(locale, namespaces, resources);

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
